import React, { useEffect, useState } from 'react';
export function StickyBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60 + 58);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `00:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-coral text-white py-2.5 px-4 text-center shadow-md" data-id="element-165">
      {/* Desktop layout */}
      <p className="hidden md:flex items-center justify-center gap-2 text-base font-medium" data-id="element-166">
        <span className="flex items-center gap-2" data-id="element-167">
          <span className="animate-pulse" data-id="element-168">🔴</span>
          <strong data-id="element-169">FLASH SALE:</strong> Get the Snap-Back Bundle at 85% OFF
          before the timer hits zero.
        </span>
        <span className="bg-white/20 px-3 py-1 rounded-full font-bold tracking-wider" data-id="element-170">
          Price increases to $47.00 in: {formatTime(timeLeft)}
        </span>
      </p>

      {/* Mobile layout - same copy, better stacking */}
      <div className="flex md:hidden flex-col items-center gap-1.5" data-id="element-171">
        <p className="text-sm font-medium leading-snug" data-id="element-172">
          <span className="animate-pulse mr-1" data-id="element-173">🔴</span>
          <strong data-id="element-174">FLASH SALE:</strong> Get the Snap-Back Bundle at 85% OFF
          before the timer hits zero.
        </p>
        <span className="bg-white/20 px-3 py-0.5 rounded-full font-bold text-sm tracking-wider" data-id="element-175">
          Price increases to $47.00 in: {formatTime(timeLeft)}
        </span>
      </div>
    </div>;
}